import { FaqProps, stateStatusType } from './actionType';

export interface FetchFaqState {
  isLoading: boolean;
  error: string | null;
  faq: FaqProps[] | null;
  status: stateStatusType | null;
}

export interface GenericFaqState {
  isLoading: boolean;
  error: string | null;
  status: stateStatusType | null;
}

export const initialFetchFaqState: FetchFaqState = {
  isLoading: false,
  error: null,
  faq: null,
  status: null,
};

export const initialGenericFaqState: GenericFaqState = {
  isLoading: false,
  error: null,
  status: null,
};

export interface FaqState {
  fetchFaqState: FetchFaqState;
  genericFaqState: GenericFaqState;
  children?: React.ReactNode;
}

export const initialState: FaqState = {
  fetchFaqState: initialFetchFaqState,
  genericFaqState: initialGenericFaqState,
};




